import {type SelectedCompany, readSelectedCompanies, writeSelectedCompanies} from './selected-companies-storage'

export const PORTAL_COMPANIES_SYNC_PARAM = 'brainSyncCompanies'

export function buildPortalUrlWithCompaniesSync(baseUrl: string, companies?: SelectedCompany[]): string {
  const selection = companies ?? readSelectedCompanies()
  if (!selection.length) return baseUrl

  const url = new URL(baseUrl, window.location.origin)

  url.searchParams.set(PORTAL_COMPANIES_SYNC_PARAM, JSON.stringify(selection))

  return url.toString()
}

export function consumeCompaniesSyncFromUrl(): SelectedCompany[] {
  const url = new URL(window.location.href)
  const raw = url.searchParams.get(PORTAL_COMPANIES_SYNC_PARAM)

  if (!raw) return []

  url.searchParams.delete(PORTAL_COMPANIES_SYNC_PARAM)
  window.history.replaceState(window.history.state, '', url.toString())

  try {
    const companies = parseCompaniesSyncPayload(raw)
    const parsed = Array.isArray(companies)
      ? companies.flatMap((item) => {
          if (typeof item !== 'object' || item == null) return []

          const id = Number((item as SelectedCompany).id)
          const name = String((item as SelectedCompany).name ?? '')

          if (!Number.isFinite(id) || !name) return []

          return [{id, name}]
        })
      : []

    if (parsed.length) writeSelectedCompanies(parsed)

    return parsed
  } catch {
    return []
  }
}

function parseCompaniesSyncPayload(raw: string): unknown {
  try {
    return JSON.parse(raw)
  } catch {
    return JSON.parse(decodeURIComponent(raw))
  }
}
